export const enableJs = () => {
  document.documentElement.classList.replace('no-js', 'js');
};
